import { WorkloadType } from '@/components/Workload/types';
import get from 'lodash/get';
import map from 'lodash/map';
import max from 'lodash/max';
import { ChangeLogOptionItem } from '../components/detail-changelog';

const { DEPLOYMENT, STATEFULSET, DAEMONSET } = WorkloadType;

/** 处理当前历史版本 */
export const useWorkloadVersion = (
  module: WorkloadType,
  details: any,
  versions: ChangeLogOptionItem[],
) => {
  switch (module) {
    case DEPLOYMENT:
      return get(details, 'metadata.annotations["deployment.kubernetes.io/revision"]');
    case STATEFULSET:
    case DAEMONSET:
    default: {
      const maxRevision = max(map(versions, 'version'));
      const cur = versions.find((item) => item.name === get(details, 'status.currentRevision'));
      const revision = cur ? cur.version : maxRevision;
      return revision;
    }
  }
};
